import { Factory, StandardEntity } from '@infodata-group/inf-commons';
import { AlarmLite } from '../../model/alarm/alarm-lite';
import { AlarmLiteDto } from '../../dto/alarm/alarm-lite.dto';

export class AlarmLiteFactory implements Factory<AlarmLite> {
  getApi(): string {
    return 'lite/alarms/';
  }
  build(o: AlarmLiteDto): AlarmLite {
    try {
      const alarm = new AlarmLite(o.id, o.title);
      alarm.date = o.date;
      alarm.hour = o.hour;
      if (o.type) {
        alarm.type = new StandardEntity(o.type.id, o.type.label, 'label');
      }
      if (o.agent) {
        alarm.agent = new StandardEntity(
          o.agent.id,
          `${o.agent.lastname} ${o.agent.firstname}`,
          'label',
        );
      }
      return alarm;
    } catch (e) {
      return null;
    }
  }
}
